import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { SlideshowViewer } from "./components/SlideshowViewer";

// API URL
const getApiBaseUrl = () => window.location.origin;
export const BACKEND_URL = getApiBaseUrl();
export const API = `${BACKEND_URL}/api`;

// Anonymous visitor tracking
export const getVisitorId = () => {
  let id = localStorage.getItem('union_visitor_id');
  if (!id) {
    id = `v_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('union_visitor_id', id);
  }
  return id;
};

// Reusable slideshow component
export const PageSlideshows = ({ pageTarget }) => {
  const [slideshows, setSlideshows] = useState([]);
  useEffect(() => {
    axios.get(`${API}/slideshows?page_target=${pageTarget}`).then(res => {
      setSlideshows(res.data.slideshows || []);
    }).catch(() => {});
  }, [pageTarget]);
  if (!slideshows.length) return null;
  return (
    <div className="space-y-6" data-testid={`slideshows-${pageTarget}`}>
      {slideshows.map(s => (
        <SlideshowViewer key={s.slideshow_id} slides={s.slides} title={s.title} />
      ))}
    </div>
  );
};

export const getDeviceType = () => {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
};

export const trackPageView = (page) => {
  try {
    axios.post(`${API}/analytics/pageview`, {
      visitor_id: getVisitorId(),
      page,
      referrer: document.referrer || null,
      device: getDeviceType()
    }).catch(() => {});
  } catch (e) {}
};

export const trackUnionClick = (unionId, unionName) => {
  try {
    axios.post(`${API}/analytics/union-click`, {
      visitor_id: getVisitorId(),
      union_id: unionId,
      union_name: unionName
    }).catch(() => {});
  } catch (e) {}
};

// Auth Context
export const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
